import React from 'react';
import { Select, SelectProps } from 'antd';

import { useQuery } from 'react-query';
import {
  getBranchListByMgid,
  GetBranchListByMgidParams,
} from 'services/parametersService';
import { noop } from 'lodash';

export type BranchListProps = SelectProps<any> &  {
  params: GetBranchListByMgidParams;
  onSelected?: (val: any) => void;
 
};

const BranchList = ({ params, onChange = noop,onSelected, ...otherProps }: BranchListProps) => {
 
  const { data: branches } = useQuery(
    ['getBranchListByMgid', params],
    () =>
      getBranchListByMgid({
        mgid: params.mgid,
        brname: '',
        channelcode: '',
      }).then((res) => res.list || []),
    { enabled: !!params.mgid }
  );

 
 const handleChange = (value: any, option: any) => {
onChange(value, option);
 

  if (onSelected) {
    onSelected(value);
  }


};
  return (
    <Select
      showSearch
      onChange={handleChange}
      {...otherProps}
    
    >
      {branches?.map((branch) => (
        <Select.Option value={branch.brid} key={branch.brid}>
          {branch.brname}
        </Select.Option>
      ))}
    </Select>
  );
};

export default BranchList;
